import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  UpgradeTagSize,
  UpgradeType,
} from '@freelancer/components/upgrade-tag';
import { trackByValue } from '@freelancer/ui';

@Component({
  standalone: false,
  selector: 'fl-project-contest-card-tags',
  template: `
    <div [class.ContestTags]="isContest">
      @for (
        upgrade of upgrades;
        track trackByValue($index, upgrade);
        let isFirst = $first
      ) {
        <ng-container [ngSwitch]="upgrade">
          <ng-container *ngSwitchDefault>
            <ng-container
              *ngTemplateOutlet="upgradeTemplate; context: { upgrade: upgrade }"
            ></ng-container>
          </ng-container>
          <!-- TODO: T259451 Make the tooltip arrows dynamically positioned -->
          <!-- Project upgrades -->
          @if (isProject) {
            <span
              *ngSwitchCase="UpgradeType.ASSISTED"
              i18n-matTooltip="Tooltip message for Recruiter project upgrade"
              matTooltip="This project has a recruiter assisting the client in selecting the right freelancer for the job."
            >
              <ng-container
                *ngTemplateOutlet="
                  upgradeTemplate;
                  context: { upgrade: upgrade }
                "
              ></ng-container>
            </span>
            <span
              *ngSwitchCase="UpgradeType.NDA"
              i18n-matTooltip="Tooltip message for NDA project upgrade"
              matTooltip="A signed Non-disclosure Agreement will be required in order to bid on this project."
            >
              <ng-container
                *ngTemplateOutlet="
                  upgradeTemplate;
                  context: { upgrade: upgrade }
                "
              ></ng-container>
            </span>
            <span
              *ngSwitchCase="UpgradeType.FEATURED"
              i18n-matTooltip="Tooltip message for Featured project upgrade"
              matTooltip="This is a featured project on the platform."
            >
              <ng-container
                *ngTemplateOutlet="
                  upgradeTemplate;
                  context: { upgrade: upgrade }
                "
              ></ng-container>
            </span>
            <span
              *ngSwitchCase="UpgradeType.PRIVATE"
              i18n-matTooltip="Tooltip message for Private project upgrade"
              matTooltip="Projects with this upgrade can only be viewed with Freelancer.com accounts."
            >
              <ng-container
                *ngTemplateOutlet="
                  upgradeTemplate;
                  context: { upgrade: upgrade }
                "
              ></ng-container>
            </span>
            <span
              *ngSwitchCase="UpgradeType.IP_AGREEMENT"
              i18n-matTooltip="Tooltip message for IP Agreement project upgrade"
              matTooltip="The awarded freelancer/s will need to transfer ownership of their work to the client."
            >
              <ng-container
                *ngTemplateOutlet="
                  upgradeTemplate;
                  context: { upgrade: upgrade }
                "
              ></ng-container>
            </span>
            <span
              *ngSwitchCase="UpgradeType.TECHNICAL_COPILOT"
              i18n-matTooltip="
                Tooltip message for Technical copilot project upgrade
              "
              matTooltip="One of Freelancer.com's project managers will be overseeing this project."
            >
              <ng-container
                *ngTemplateOutlet="
                  upgradeTemplate;
                  context: { upgrade: upgrade }
                "
              ></ng-container>
            </span>
            <span
              *ngSwitchCase="UpgradeType.EXTENDED"
              i18n-matTooltip="Tooltip message for Extended project upgrade"
              matTooltip="Bidding period has been extended for this project."
            >
              <ng-container
                *ngTemplateOutlet="
                  upgradeTemplate;
                  context: { upgrade: upgrade }
                "
              ></ng-container>
            </span>
          }
          <!-- Contest  upgrades -->
          @if (isContest) {
            <span
              *ngSwitchCase="UpgradeType.GUARANTEED"
              i18n-matTooltip="Tooltip message for Guaranteed contest upgrade"
              matTooltip="The contest holder guarantees a winner will be chosen and awarded the prize."
            >
              <ng-container
                *ngTemplateOutlet="
                  upgradeTemplate;
                  context: { upgrade: upgrade }
                "
              ></ng-container>
            </span>
            <span
              *ngSwitchCase="UpgradeType.FEATURED"
              i18n-matTooltip="Tooltip message for Featured contest upgrade"
              matTooltip="This is a featured contest on the platform."
            >
              <ng-container
                *ngTemplateOutlet="
                  upgradeTemplate;
                  context: { upgrade: upgrade }
                "
              ></ng-container>
            </span>
            <span
              *ngSwitchCase="UpgradeType.TOP_CONTEST"
              i18n-matTooltip="Tooltip message for Top Contest contest upgrade"
              matTooltip="Top performing freelancers have been invited to enter this contest."
            >
              <ng-container
                *ngTemplateOutlet="
                  upgradeTemplate;
                  context: { upgrade: upgrade }
                "
              ></ng-container>
            </span>
            <span
              *ngSwitchCase="UpgradeType.HIGHLIGHT"
              i18n-matTooltip="Tooltip message for Highlight contest upgrade"
              matTooltip="This is a highlighted contest on the platform."
            >
              <ng-container
                *ngTemplateOutlet="
                  upgradeTemplate;
                  context: { upgrade: upgrade }
                "
              ></ng-container>
            </span>
            <span
              *ngSwitchCase="UpgradeType.SEALED"
              i18n-matTooltip="Tooltip message for Sealed contest upgrade"
              matTooltip="Details of the contest entries can only be seen by the contest holder."
            >
              <ng-container
                *ngTemplateOutlet="
                  upgradeTemplate;
                  context: { upgrade: upgrade }
                "
              ></ng-container>
            </span>
            <span
              *ngSwitchCase="UpgradeType.NDA"
              i18n-matTooltip="Tooltip message for NDA contest upgrade"
              matTooltip="A signed Non-disclosure Agreement will be required in order to enter this contest."
            >
              <ng-container
                *ngTemplateOutlet="
                  upgradeTemplate;
                  context: { upgrade: upgrade }
                "
              ></ng-container>
            </span>
            <span
              *ngSwitchCase="UpgradeType.PRIVATE"
              i18n-matTooltip="Tooltip message for Private contest upgrade"
              matTooltip="Contests with this upgrade can only be viewed with Freelancer.com accounts."
            >
              <ng-container
                *ngTemplateOutlet="
                  upgradeTemplate;
                  context: { upgrade: upgrade }
                "
              ></ng-container>
            </span>
            <span
              *ngSwitchCase="UpgradeType.EXTENDED"
              i18n-matTooltip="Tooltip message for Extended contest upgrade"
              matTooltip="Entry period has been extended for this contest."
            >
              <ng-container
                *ngTemplateOutlet="
                  upgradeTemplate;
                  context: { upgrade: upgrade }
                "
              ></ng-container>
            </span>
          }
        </ng-container>
      }

      <ng-template
        #upgradeTemplate
        let-upgrade="upgrade"
      >
        <fl-upgrade-tag
          class="mb-xxxsmall desktop:mb-none mr-xxsmall"
          [size]="UpgradeTagSize.SMALL"
          [upgradeType]="upgrade"
        ></fl-upgrade-tag>
      </ng-template>
    </div>
  `,
  styleUrls: ['./project-contest-card-tags.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectContestCardTagsComponent {
  UpgradeType = UpgradeType;
  UpgradeTagSize = UpgradeTagSize;
  trackByValue = trackByValue;

  @Input() isProject: boolean;
  @Input() isContest: boolean;
  @Input() upgrades: any;
}
